import { AlertBadge } from '@purpur/library';
import styled from 'styled-components';

import { SkeletonCol } from '@telialt/common-skeleton-builder/src/SkeletonBuilder.styles';

export const StyledSkeleton = styled.div`
    ${SkeletonCol} {
        border-radius: 0;
    }
`;

export const DocumentsItemAlertBadge = styled(AlertBadge)`
    align-self: flex-start;
    transform: translateX(-50%);
`;
